import EntrepriseService from '../services/entreprise.service'
import { handleCookieError } from '../utils/utils.js'
import router from '@/router'

export const entrepriseModule = {
  namespaced: true,

  actions: {
    async searchEntreprise ({ commit }, rechercheEntreprise) {
      return EntrepriseService.searchEntreprise(rechercheEntreprise).then(
        response => {
          const entreprises = response.data
          commit('entreprisesOk', entreprises)
          return Promise.resolve(entreprises)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async searchEntrepriseGestDepenses ({ commit }, rechercheEntreprise) {
      return EntrepriseService.searchEntrepriseGestDepenses(rechercheEntreprise).then(
        response => {
          const entreprises = response.data
          commit('entreprisesOk', entreprises)
          return Promise.resolve(entreprises)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async searchOperations ({ commit }, rechercheOperation) {
      return EntrepriseService.searchOperations(rechercheOperation).then(
        response => {
          const operations = response.data
          return Promise.resolve(operations)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async searchOperationsAdmin ({ commit }, rechercheOperation) {
      return EntrepriseService.searchOperationsAdmin(rechercheOperation).then(
        response => {
          commit('actualOperationSearch', rechercheOperation)
          const operations = response.data
          commit('putListOperationsInStore', operations)
          return Promise.resolve(operations)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async searchRapports ({ commit }, rechercheOperation) {
      return EntrepriseService.searchRapports(rechercheOperation).then(
        response => {
          const rapports = response.data
          return Promise.resolve(rapports)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async downloadRapportFile ({ commit }, rechercheOperation) {
      return EntrepriseService.downloadRapportFile(rechercheOperation).then(
        response => {
          const rapports = response.data
          return Promise.resolve(rapports)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getParcCartes ({ commit }, rechercheOperation) {
      return EntrepriseService.getParcCartes(rechercheOperation).then(
        response => {
          commit('putParcCartesInStore', response.data)
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async putEditedCardInStore ({ commit }, editedCarte) {
      commit('putEditedCardInStore', editedCarte)
    },
    async getInfosPorteur ({ commit }, rechercheOperation) {
      return EntrepriseService.getInfosPorteur(rechercheOperation).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getRelevesOperations ({ commit }, telechargementOperations) {
      return EntrepriseService.getRelevesOperations(telechargementOperations).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getFileOperationsPorteur ({ commit }, [telechargementOperations, responseTypeFile]) {
      return EntrepriseService.getFileOperationsPorteur(telechargementOperations, responseTypeFile).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async downloadRelevesPorteurs ({ commit }, filesToDownload) {
      return EntrepriseService.downloadRelevesPorteurs(filesToDownload).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    selectListOperations ({ commit }, listOperations) {
      commit('putListOperationsInStore', listOperations)
    },
    deleteListOperations ({ commit }) {
      commit('deleteListOperations')
    }
  },
  mutations: {
    entreprisesOk (state, entreprises) {
      state.restrictedEntrepriseIdList = entreprises
    },
    actualOperationSearch (state, rechercheOperation) {
      state.rechercheOperation = rechercheOperation
    },
    putEditedCardInStore (state, editedCarte) {
      state.editedCarte = editedCarte
    },
    putParcCartesInStore (state, parcCartes) {
      state.parcCartes = parcCartes
    },
    deleteListOperations (state) {
      state.listOperations = []
    },
    putListOperationsInStore (state, listOperations) {
      state.listOperations = listOperations
    }
  }
}
